/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { InterviewActionItem } from "./InterviewActionItem";
import {
  InterviewActionItemFromJSON,
  InterviewActionItemFromJSONTyped,
  InterviewActionItemToJSON,
  InterviewActionItemToJSONTyped,
} from "./InterviewActionItem";
import type { MeetingParticipant } from "./MeetingParticipant";
import {
  MeetingParticipantFromJSON,
  MeetingParticipantFromJSONTyped,
  MeetingParticipantToJSON,
  MeetingParticipantToJSONTyped,
} from "./MeetingParticipant";

/**
 *
 * @export
 * @interface InterviewPreview
 */
export interface InterviewPreview {
  /**
   *
   * @type {string}
   * @memberof InterviewPreview
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof InterviewPreview
   */
  jamieUrl: string;
  /**
   *
   * @type {string}
   * @memberof InterviewPreview
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof InterviewPreview
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof InterviewPreview
   */
  summaryShort?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewPreview
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {Array<MeetingParticipant>}
   * @memberof InterviewPreview
   */
  participants: Array<MeetingParticipant>;
  /**
   *
   * @type {Array<InterviewActionItem>}
   * @memberof InterviewPreview
   */
  actionItems: Array<InterviewActionItem>;
}

/**
 * Check if a given object implements the InterviewPreview interface.
 */
export function instanceOfInterviewPreview(
  value: object,
): value is InterviewPreview {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("jamieUrl" in value) || value["jamieUrl"] === undefined) return false;
  if (!("participants" in value) || value["participants"] === undefined)
    return false;
  if (!("actionItems" in value) || value["actionItems"] === undefined)
    return false;
  return true;
}

export function InterviewPreviewFromJSON(json: any): InterviewPreview {
  return InterviewPreviewFromJSONTyped(json, false);
}

export function InterviewPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InterviewPreview {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    participants: (json["participants"] as Array<any>).map(
      MeetingParticipantFromJSON,
    ),
    actionItems: (json["actionItems"] as Array<any>).map(
      InterviewActionItemFromJSON,
    ),
  };
}

export function InterviewPreviewToJSON(json: any): InterviewPreview {
  return InterviewPreviewToJSONTyped(json, false);
}

export function InterviewPreviewToJSONTyped(
  value?: InterviewPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    summaryMarkdown: value["summaryMarkdown"],
    participants: (value["participants"] as Array<any>).map(
      MeetingParticipantToJSON,
    ),
    actionItems: (value["actionItems"] as Array<any>).map(
      InterviewActionItemToJSON,
    ),
  };
}
